"use strict";

var _regeneratorRuntime = require("/var/www/dev/prosper/admin.samsung-prosper.dev.pannovate.net/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _BaseModel2 = _interopRequireDefault(require("../../../logic/model/BaseModel"));

var _Api = _interopRequireDefault(require("../../../logic/api/Api"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var CardModel = /*#__PURE__*/function (_BaseModel) {
  _inherits(CardModel, _BaseModel);

  function CardModel() {
    _classCallCheck(this, CardModel);

    return _possibleConstructorReturn(this, _getPrototypeOf(CardModel).apply(this, arguments));
  }

  _createClass(CardModel, [{
    key: "getListUrl",

    /**
     * Get list url
     */
    value: function getListUrl() {
      return 'cards/list';
    }
    /**
     * Get details url
     */

  }, {
    key: "getDetailsUrl",
    value: function getDetailsUrl() {
      return 'cards/details';
    }
    /**
      * Get submit url
      */

  }, {
    key: "getSubmitUrl",
    value: function getSubmitUrl() {
      return 'cards/order';
    }
    /**
     * Get download url
     */

  }, {
    key: "getDownloadUrl",
    value: function getDownloadUrl() {
      return 'cards/list/download';
    }
    /**
     * Get default table columns
     */

  }, {
    key: "getTableColumns",
    value: function getTableColumns() {
      return [{
        name: 'id',
        label: 'Id',
        sortable: true,
        type: 'field'
      }, {
        name: 'pan',
        label: 'PAN',
        sortable: false,
        type: 'field'
      }, {
        name: 'userFullName',
        label: 'User',
        sortable: false,
        type: 'field'
      }, {
        name: 'balance',
        label: 'Balance',
        sortable: false,
        type: 'field'
      }, {
        name: 'expires',
        label: 'Expires',
        sortable: false,
        type: 'field'
      }, {
        name: 'status',
        label: 'Status',
        sortable: false,
        type: 'field'
      }, {
        name: null,
        label: 'Actions',
        sortable: false,
        type: 'actions'
      }];
    }
    /**
    * Get transaction of the card
    *
    * @param {Integer} id Id of the card
    */

  }, {
    key: "getTransaction",
    value: function () {
      var _getTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(id) {
        var result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                alert(id);
                _context.next = 3;
                return _Api["default"].call('transaction/list', {
                  id: id
                });

              case 3:
                result = _context.sent;
                return _context.abrupt("return", result.data);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function getTransaction(_x) {
        return _getTransaction.apply(this, arguments);
      }

      return getTransaction;
    }()
    /**
    * Change freeze status
    *
    * @param {Object} card Card to change freeze status
    * @param {Bool} status Frozen or not
    */

  }, {
    key: "changeFreezeStatus",
    value: function () {
      var _changeFreezeStatus = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(card, status) {
        var response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.freezeCard(card.id, status);

              case 2:
                response = _context2.sent;

                if (!response.success) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return", true);

              case 5:
                return _context2.abrupt("return", false);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function changeFreezeStatus(_x2, _x3) {
        return _changeFreezeStatus.apply(this, arguments);
      }

      return changeFreezeStatus;
    }()
  }, {
    key: "freezeCard",
    value: function () {
      var _freezeCard = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(id, status) {
        var response;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _Api["default"].call('card/lock-unlock', {
                  id: id,
                  locked: !!status
                });

              case 2:
                response = _context3.sent;
                return _context3.abrupt("return", response);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function freezeCard(_x4, _x5) {
        return _freezeCard.apply(this, arguments);
      }

      return freezeCard;
    }()
    /**
    * Change stolen status
    *
    * @param {Object} card Card to change stolen status
    * @param {Bool} status Stolen or not
    */

  }, {
    key: "changeStolenStatus",
    value: function () {
      var _changeStolenStatus = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(card, status) {
        var response;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.stolenCard(card.id, status);

              case 2:
                response = _context4.sent;

                if (!response.success) {
                  _context4.next = 5;
                  break;
                }

                return _context4.abrupt("return", true);

              case 5:
                return _context4.abrupt("return", false);

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function changeStolenStatus(_x6, _x7) {
        return _changeStolenStatus.apply(this, arguments);
      }

      return changeStolenStatus;
    }()
  }, {
    key: "regenerateCard",
    value: function () {
      var _regenerateCard = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(card, status) {
        var response;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _Api["default"].call('card/regenerate', {
                  id: card.id,
                  status: status
                });

              case 2:
                response = _context5.sent;

                if (!response.success) {
                  _context5.next = 5;
                  break;
                }

                return _context5.abrupt("return", response.data);

              case 5:
                return _context5.abrupt("return", response.data);

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function regenerateCard(_x8, _x9) {
        return _regenerateCard.apply(this, arguments);
      }

      return regenerateCard;
    }()
    /**
     * Marks card as stolen
     *
     * @param {integer} id Id of the card
     */

  }, {
    key: "stolenCard",
    value: function () {
      var _stolenCard = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(id) {
        var response;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _Api["default"].call('card/report-stolen', {
                  id: id
                });

              case 2:
                response = _context6.sent;
                return _context6.abrupt("return", response);

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function stolenCard(_x10) {
        return _stolenCard.apply(this, arguments);
      }

      return stolenCard;
    }()
  }, {
    key: "update3DS",
    value: function () {
      var _update3DS = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(id) {
        var response;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return _Api["default"].call('payment-device/update-3ds', {
                  id: id
                });

              case 2:
                response = _context7.sent;
                return _context7.abrupt("return", response.success);

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function update3DS(_x11) {
        return _update3DS.apply(this, arguments);
      }

      return update3DS;
    }()
  }, {
    key: "changeCardStatus",
    value: function () {
      var _changeCardStatus = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(id, status) {
        var response;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return _Api["default"].call('card/change-status', {
                  id: id,
                  status: status
                });

              case 2:
                response = _context8.sent;
                return _context8.abrupt("return", response.success);

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function changeCardStatus(_x12, _x13) {
        return _changeCardStatus.apply(this, arguments);
      }

      return changeCardStatus;
    }()
  }]);

  return CardModel;
}(_BaseModel2["default"]);

exports["default"] = CardModel;